import { demoAllGroups } from "assets/data/communities";
import { useState } from "react";
import { Link } from "react-router-dom";
import { Card, SVG } from "ui";
import Breadcrumb, { BreadcrumbObject } from "ui/files/core/Breadcrumb";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { posts } from "assets/data/posts";
import { CommunityHeader, FeedPost, MessageCommunityModal } from "components";
import PeopleAltRoundedIcon from "@mui/icons-material/PeopleAltRounded"; // users
import AccountCircleRoundedIcon from "@mui/icons-material/AccountCircleRounded"; //admin
import TodayRoundedIcon from "@mui/icons-material/TodayRounded"; // date
import CheckCircleOutlineRoundedIcon from "@mui/icons-material/CheckCircleOutlineRounded"; // active
import BlockRoundedIcon from "@mui/icons-material/BlockRounded"; // blocked
import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded"; // deleted
import SendRoundedIcon from "@mui/icons-material/SendRounded";

const Community = () => {
    const breadcrumb: BreadcrumbObject[] = [
        {
            path: "/",
            text: "Main"
        },
        {
            path: "/communities",
            text: "Communities"
        }
    ];

    const [group, setGroup] = useState(demoAllGroups[0]);

    const handleBlock = () => {
        setGroup(() => ({ ...group, status: "blocked" }));
    };
    const handleDelete = () => {
        setGroup(() => ({ ...group, status: "deleted" }));
    };
    const handleRestore = () => {
        setGroup(() => ({ ...group, status: "active" }));
    };

    const [openModal, setOpenModal] = useState(false);

    const handleSendMsg = () => {
        setOpenModal(true);
    };

    return (
        <>
            <section className="w-full h-full flex flex-col relative">
                <div className="w-full h-full flex relative  overflow-auto">
                    <div className="w-full flex flex-col">
                        <div className="w-full text-center">
                            <Breadcrumb
                                breadcrumb={breadcrumb}
                                currentPath={group.title}
                            />
                        </div>

                        <div className="w-full justify-center items-start flex flex-wrap gap-5 py-10 px-10 ">
                            <div className="w-full flex items-center justify-between gap-2 ">
                                <Link
                                    to="/communities"
                                    className="flex justify-start items-center gap-3"
                                >
                                    <SVG svg="arrow-left" size={18} />

                                    <span className="text-sm dark:text-white">
                                        Back to Communities list
                                    </span>
                                </Link>

                                <div className={`my-drop-down relative w-fit`}>
                                    {/* <div> */}
                                    <MoreVertIcon
                                        fontSize="medium"
                                        className="my-drop-down-more-vertical dark:text-white"
                                    />
                                    {/* </div> */}
                                    <div
                                        className={`my-drop-down-div right bg-neutral-100 dark:bg-momeento-300 rounded`}
                                    >
                                        <ul>
                                            <li
                                                className={`my-drop-down-item dark:text-white rounded`}
                                                onClick={() => {
                                                    if (
                                                        group.status ===
                                                        "blocked"
                                                    ) {
                                                        handleRestore();
                                                    } else {
                                                        handleBlock();
                                                    }
                                                }}
                                            >
                                                {group.status === "blocked"
                                                    ? "Unblock"
                                                    : "Block"}
                                            </li>
                                            <li
                                                className={`my-drop-down-item dark:text-white rounded`}
                                                onClick={() => {
                                                    if (
                                                        group.status ===
                                                        "deleted"
                                                    ) {
                                                        handleRestore();
                                                    } else {
                                                        handleDelete();
                                                    }
                                                }}
                                            >
                                                {group.status === "deleted"
                                                    ? "Restore"
                                                    : "Delete"}
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <CommunityHeader group={group} />
                            <div className="w-full flex flex-col lg:flex-row-reverse gap-10 justify-center items-start">
                                <div className="pt-10 pb-0 lg:pb-10 w-full lg:w-1/3">
                                    <Card style={{ borderRadius: "0.75rem" }}>
                                        <h2 className="font-bold text-lg dark:text-white">
                                            About
                                        </h2>
                                        <ul className="w-full flex flex-col justify-start items-start gap-3 dark:text-white">
                                            <li className="w-full flex justify-start items-center gap-2">
                                                <PeopleAltRoundedIcon fontSize="small" />
                                                <Link
                                                    to={`/communities/view/${group.id}/members`}
                                                >
                                                    5 Members
                                                </Link>
                                            </li>
                                            <li className="w-full flex justify-start items-center gap-2">
                                                <AccountCircleRoundedIcon fontSize="small" />
                                                <div>
                                                    <h4 className="pb-1 text-md font-semibold">
                                                        Group Admin
                                                    </h4>
                                                    <p>Jhon Smith</p>
                                                </div>
                                            </li>
                                            <li
                                                className={`w-full flex justify-start items-center gap-2 ${group.status !== "active" && "text-red-500"}`}
                                            >
                                                {group.status === "active" && (
                                                    <CheckCircleOutlineRoundedIcon fontSize="small" />
                                                )}
                                                {group.status === "blocked" && (
                                                    <BlockRoundedIcon fontSize="small" />
                                                )}
                                                {group.status === "deleted" && (
                                                    <DeleteRoundedIcon fontSize="small" />
                                                )}
                                                <div>
                                                    {group.status === "active"
                                                        ? "Active"
                                                        : group.status ===
                                                            "blocked"
                                                          ? "Blocked"
                                                          : "Deleted"}
                                                </div>
                                            </li>
                                            <li className="w-full flex justify-start items-center gap-2">
                                                <TodayRoundedIcon fontSize="small" />
                                                <div>
                                                    <h4 className="pb-1 text-md font-semibold">
                                                        Create Date
                                                    </h4>
                                                    <p>Dec 30, 2023</p>
                                                </div>
                                            </li>
                                            <li className="w-full flex justify-start items-center gap-2">
                                                <SendRoundedIcon fontSize="small" />
                                                <button
                                                    className="pb-1 text-md font-semibold"
                                                    onClick={handleSendMsg}
                                                >
                                                    send message
                                                </button>
                                            </li>
                                        </ul>
                                    </Card>
                                </div>
                                <div className="community-posts pt-0 lg:pt-10 pb-10 w-full lg:w-2/3">
                                    {posts.map((post) => (
                                        <FeedPost post={post} key={post.id} />
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <MessageCommunityModal
                open={openModal}
                setOpen={setOpenModal}
                group={group}
            />
        </>
    );
};

export default Community;
